import { Component,
         OnInit,
         Injector,
         ViewEncapsulation } from '@angular/core';
import { Router,
         NavigationEnd }     from '@angular/router';

import { MenuService }       from '../../core/menu/menu.service';
import { SettingsService }   from '../../shared/settings/settings.service';

import { AuthService }       from 'ng2-ui-auth';
import { ConfigService }     from '../../services/configuracion/config.service';

declare var $: any;

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SidebarComponent implements OnInit {
  menu: Array<any>;
  router: Router;
  user: any;
  sidebarOffcanvasVisible: boolean;

  constructor(
    private menuService: MenuService,
    public settings: SettingsService,
    public configService: ConfigService,
    public auth: AuthService,
    private injector: Injector
  ) {
    this.menu = menuService.getMenuSorted();

    this.user = this.auth.getPayload().sub;

    this.user.imagen = [
      configService.getApiUrl(),
      'usuario',
      this.user.id,
      'imagen'
    ].join('/');
  }

  ngOnInit() {
    this.router = this.injector.get(Router);
    this.router.events
        .filter(event => event instanceof NavigationEnd)
        .subscribe((event) => {
          this.settings.app.sidebar.visible = false;

          document.body.className = 'theme-imm smooth-scroll';
        });
  }

  closeSidebar() {
    this.settings.app.sidebar.visible = false;

    // document.body.className = 'theme-imm smooth-scroll';
  }

  handleSidebar(event) {
    let item = this.getItemElement(event);
    // check click is on a tag
    if (!item) return;

    let ele = $(item),
    liparent = ele.parent()[0];

    let lis = ele.parent().parent().children(); // markup: ul > li > a
    // remove .active from childs
    lis.find('li').removeClass('active');
    // remove .active from siblings ()
    $.each(lis, function(key, li) {
      if (li !== liparent)
        $(li).removeClass('active');
    });
    let next = ele.next();
    if (next.length && next[0].tagName === 'UL') {
      ele.parent().toggleClass('active');
      event.preventDefault();
    }

    // document.body.className = 'theme-imm smooth-scroll';
  }

  // find the a element in click context
  // doesn't check deeply, asumens two levels only
  getItemElement(event) {
    let element = event.target,
        parent = element.parentNode;
    if (element.tagName.toLowerCase() === 'a') {
      return element;
    }
    if (parent.tagName.toLowerCase() === 'a') {
      return parent;
    }
    if (parent.parentNode.tagName.toLowerCase() === 'a') {
      return parent.parentNode;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/layout/sidebar/sidebar.component.ts